// extracted by mini-css-extract-plugin
export var dataCell = "_pk-2";
export var dataRow = "_pk-0";
export var headerRow = "_pk-1";